import { render, staticRenderFns } from "./InstalledPrintersInline.vue?vue&type=template&id=2207abd0&scoped=true&"
import script from "./InstalledPrintersInline.vue?vue&type=script&lang=js&"
export * from "./InstalledPrintersInline.vue?vue&type=script&lang=js&"
import style0 from "./InstalledPrintersInline.vue?vue&type=style&index=0&id=2207abd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2207abd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSelect,VTextField})
